'use strict';

import Analytics from  '../Analytics/Analytics';
import config from '../../js/config';
import mediator from '../../js/mediator';
import { EnableAdobeAnalytics } from '../../utilities/featureFlags';
import $ from 'jquery';
var _ = require('underscore'),
  utilities = require('../../js/utilities'),
  CarouselBaseView = require('./CarouselBaseView'),
  globalisation = require('../../utilities/globalisation'),
  HeroCarouselView;

var clickedFlag = 0;
var heroCarousal = false;
HeroCarouselView = CarouselBaseView.extend({
  options: {
    accessibility: false,
    slideClass: '.HeroCarousel-slide',
    paginationClass: 'HeroCarousel-pagination',
    arrows: false,
    speed: 600,
    fade: true,
    autoplay: true,
    paused: true,
    customPaging: function(slider, i) {
      var h2 = slider.$slides[i].getElementsByClassName('HeroCarousel-header');
      var headingText = '';
      if (EnableAdobeAnalytics.isEnabled() && !heroCarousal) {
        heroCarousal = true;
        Analytics.adobeCarousalImageImp(h2[0].innerText.trim() || undefined);
      }
      var totalSlides = slider.$slides.length;
      if (h2 && h2.length === 1) {
        headingText = $(h2[0]).text().replace(/[\r\n]+/gm, '').trim();
      }
      return '<button class="HeroCarousel-pagination-button" type="button"><span class="sr-only">button ' + (i + 1) + ' of ' + totalSlides  + ' ' + headingText + '</span></button>';
    },

    transitionDelay: 600,
    timer: null
  },

  initialize: function(options) {

    if (utilities._isMobileOrTabletDevice()) {
      options.autoplay = false;
      if (HeroCarouselView.__super__.options) {
        HeroCarouselView.__super__.options.autoplay = false;
      }
      if (this.options) {
        this.options.autoplay = false;
      }
    }
    this.options = _.defaults(this.options, HeroCarouselView.__super__.options);
    HeroCarouselView.__super__.initialize.call(this, options);
  },

  events: {
    'click .HeroCarousel-slide': 'pushPromoAnalyticsData',
    'click .HeroCarousel-pagination-button': 'redirectToSlide',
    'click .playButton': 'pauseVideo'
  },

  getDataAttributes: function() {
    HeroCarouselView.__super__.getDataAttributes.call(this);

    var transitionDelay = this.$el.data('transition-delay');
    if (transitionDelay !== undefined) {
      this.options.transitionDelay = transitionDelay;
    }
  },

  pauseVideo: function() {
    let play = this.$el[0].lastElementChild.lastElementChild.firstElementChild;
    let spanText = this.$el[0].lastElementChild.lastElementChild.lastElementChild;
    let playBtn = this.$el[0].lastElementChild.lastElementChild;
    var slick = this.$el.slick('getSlick');
    let spanClass = play.className;
    if (spanClass === 'play-button play-button--playing') {
      play.className = '';
      play.className = 'play-button play-button--paused';
      playBtn.setAttribute('aria-label' , 'Play Slide or Carousel');
      if (spanText) {
        spanText.innerHTML = globalisation.pluraliseAndTranslate('common', 'play');
      }
      if (HeroCarouselView.__super__.options) {
        HeroCarouselView.__super__.options.autoplay = false;
      }
      if (!slick.paused) {
        slick.pause();
        slick.options.autoplay = false;
      }
    }
    if (spanClass === 'play-button play-button--paused') {
      play.className = '';
      play.className = 'play-button play-button--playing';
      playBtn.setAttribute('aria-label' , 'Pause Slide or Carousel');
      if (spanText) {
        spanText.innerHTML = globalisation.pluraliseAndTranslate('common', 'pause');
      }
      if (HeroCarouselView.__super__.options) {
        HeroCarouselView.__super__.options.autoplay = true;
      }
      if (slick.paused) {
        const autoplaySpeed = HeroCarouselView.__super__.options ? (HeroCarouselView.__super__.options.autoplaySpeed || HeroCarouselView.__super__.options.delay) : (slick.options.delay ? slick.options.delay : 5000);
        slick.options.delay = 5;
        slick.options.autoplaySpeed = 5;
        if (HeroCarouselView.__super__.options) {
          HeroCarouselView.__super__.options.autoplaySpeed = 5;
        }
        slick.play();
        slick.options.autoplay = true;
        slick.options.delay = autoplaySpeed;
        slick.options.autoplaySpeed = autoplaySpeed;
        if (HeroCarouselView.__super__.options) {
          HeroCarouselView.__super__.options.autoplaySpeed = autoplaySpeed;
        }
      }
    }
  },
  initialiseCarouselEvents: function() {
    HeroCarouselView.__super__.initialiseCarouselEvents.call(this);
    // Override the default animations with a delay to allow custom CSS animations time to fire
    var slick = this.$el.slick('getSlick');

    this.overrideMethod(slick, 'fadeSlide', this.delayMethod);
    this.overrideMethod(slick, 'animateSlide', this.delayMethod);

    // Add event listeners for slide changes
    this.$el.on('beforeChange', this.onBeforeChangeSlide);
    this.$el.on('afterChange', this.onAfterChangeSlide);

    if (slick.$dots && slick.$dots.length) {
      var $dotElms = slick.$dots.find('li button');
      slick.$dots.removeAttr('role');
      slick.$dots.find('li').removeAttr('aria-hidden');
      if ($dotElms && $dotElms.length) {
        $dotElms.attr('aria-current', false);
        $dotElms.eq(slick.currentSlide).attr('aria-current', true);
        $dotElms.each(function() {
          $(this).on('focus', function() {
            slick.$dots.find('li').removeAttr('aria-hidden');
          });
          $(this).on('click', function() {
            slick.$dots.find('li').removeAttr('aria-hidden');
          });
        });
      }
      let div = document.createElement('div');
      div.className = 'iconTag';
      let a = document.createElement('button');
      a.className = 'playButton';
      let spanicon = document.createElement('span');
      spanicon.className = 'play-button play-button--playing';
      a.setAttribute('aria-label' , 'Pause Slide or Carousel');
      a.appendChild(spanicon);
      let span = document.createElement('span');
      span.className = 'icon-text';
      span.innerHTML = globalisation.pluraliseAndTranslate('common', 'pause');
      span.setAttribute('aria-hidden' , true);
      a.appendChild(span);
      div.appendChild(a);
      slick.$dots[0].parentNode.appendChild(div);
      this.$('.slick-list').removeAttr('aria-live');
    }

    if (slick.$slides && slick.$slides.length) {
      //Provide the number of carousel
      var totalSlides = slick.$slides.length;
      slick.$slides.each(function(index) {
        $(this).find('a').each(function() {
          $(this).attr('tabindex', '-1');
        });
        let $link = $(this).find('a.HeroCarousel-link:first');
        if ($link && $link.length)
          $link.prepend('<span class="sr-only">Slide ' + (index + 1) + ' of ' + totalSlides + '</span>');
      });

      let $slide = slick.$slides.eq(slick.currentSlide);
      $slide.find('a').each(function() {
        $(this).removeAttr('tabindex');
      });
      HeroCarouselView.__super__.resizeCarosalContent($slide);
    }
  },

  pushPromoAnalyticsData: function(event) {
    event.preventDefault();
    this.$elAnalyticsData = $(event.currentTarget).find('.HeroCarousel-link');
    if (this.$elAnalyticsData) {
      this.analyticsData = this.$elAnalyticsData.data('analytics');
      this.redirectUrl = this.$elAnalyticsData.data('redirectUrl');
      if ($(event.target).hasClass('HeroCarousel-button')) {
        this.redirectUrl = event.target.getAttribute('href');
      }
      if (this.analyticsData) {
        let promoData = {
          event: config.analytics.eventTypes.PromoClick,
          id: this.analyticsData.PromotionId,
          name: this.analyticsData.PromotionName,
          creative: this.analyticsData.PromotionCreative,
          position: this.analyticsData.PromotionPosition
        }
        Analytics.pushToECommercePromotionalEventFramework(promoData);
      }
    }
    window.open(this.redirectUrl, '_self');
  },

  onBeforeChangeSlide: function(event, slick, currentSlide, nextSlide) {
    var $currentSlide = slick.$slides.eq(currentSlide),
      $nextSlide = slick.$slides.eq(nextSlide);

    // Remove previous styles
    $nextSlide.removeClass('slide-in-forward slide-out-forward');

    // Add css animation classes
    $nextSlide.addClass('slide-in-forward');
    $currentSlide.addClass('slide-out-forward');
    if (slick.$dots && slick.$dots.length) {
      slick.$dots.find('li button').eq(currentSlide).attr('aria-current', false);
    }
    if ($currentSlide && $currentSlide.length) {
      var $ancharTags = $currentSlide.find('a');
      if ($ancharTags && $ancharTags.length) {
        $ancharTags.each(function() {
          $(this).attr('tabindex', '-1');
          $(this).attr('aria-hidden', true);
        });
      }
    }

    if ($nextSlide && $nextSlide.length) {
      $ancharTags = $nextSlide.find('a');
      if ($ancharTags && $ancharTags.length) {
        $ancharTags.each(function() {
          $(this).removeAttr('tabindex');
          $(this).removeAttr('aria-hidden');
        });
      }
    }
  },

  onAfterChangeSlide: function(event, slick, currentSlide) {
    const $slDots = slick.$dots;
    if ($slDots && $slDots.length) {
      const liElms = $slDots.find('li');
      if (liElms && liElms.length) {
        liElms.removeAttr('aria-hidden');
      }
    }
    var $currentSlide = slick.$slides.eq(currentSlide);
    $currentSlide.removeClass('slide-in-forward slide-out-forward');
    if (slick.$dots && slick.$dots.length) {
      slick.$dots.find('li button').eq(currentSlide).attr('aria-current',true);
      //show description
      slick.$dots.find('li button').eq(currentSlide).find('SPAN').each(function(index) {
        if (index) {
          $(this).removeAttr('aria-hidden');
          $(this).css('display', '');
        }
      });
    }
    if (clickedFlag === 1) {
      $currentSlide.find('.HeroCarousel-link').focus();
      clickedFlag = 0;
    }
    mediator.trigger(config.events.carousel.slideChanged, this.$el);

    let $slide = $currentSlide;
    if (EnableAdobeAnalytics.isEnabled() && $slide.find('h2')) {
      Analytics.adobeCarousalImageImp($slide.find('h2')[0].innerText.trim() || undefined);
    }
    HeroCarouselView.__super__.resizeCarosalContent($slide);
  },

  redirectToSlide: function() {
    clickedFlag = 1;
  },

  // Override a method with another, passing the original as a parameter
  overrideMethod: function(object, methodName, callback) {
    object[methodName] = callback.call(this, object[methodName]);
  },

  // Delay the calling of a method
  delayMethod: function(originalMethod) {
    var carousel = this;

    return function() {
      var context = this,
        args = arguments;

      _.delay(function() {
        originalMethod.apply(context, args);
      }, carousel.options.transitionDelay);  // This time is the time the css animation takes
    };
  }

}, {
  create: function($parent) {
    $parent.find('.HeroCarousel').each(function(n, el) {
      new HeroCarouselView({
        el: el
      });
    });
  }
});

module.exports = HeroCarouselView;



// WEBPACK FOOTER //
// ./assets/components/Carousel/HeroCarouselView.js